import PropTypes from 'prop-types';
import React from 'react';
import { partnerShape } from '../types';
import BasePartnerAppSitesSummary from './BasePartnerAppSitesSummary';
import UserConfigurationAppSitesSummary, { USER_CONFIGURATION_PARTNER_NAMES } from './UserConfigurationAppSitesSummary';

// TODO new shelf will use the accountsSupport, remove the const later
const hasUserConfiguration = (partner, accountsSupport) =>
    USER_CONFIGURATION_PARTNER_NAMES.includes(partner.name) || accountsSupport;

const PartnerAppSitesSummaryFactory = props => {
    const { partner, accountsSupport } = props;

    if (hasUserConfiguration(partner, accountsSupport)) {
        return <UserConfigurationAppSitesSummary {...props} />;
    } else {
        return <BasePartnerAppSitesSummary {...props} />;
    }
};

PartnerAppSitesSummaryFactory.propTypes = {
    partner: partnerShape.isRequired,
    accountsSupport: PropTypes.bool,
};

export default PartnerAppSitesSummaryFactory;
